"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchInput = void 0;
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var draft_form_1 = require("@kaizen/draft-form");
var provider_1 = require("../../provider");
var SearchInput_module_scss_1 = __importDefault(require("./SearchInput.module.scss"));
var SearchInput = function (_a) {
    var label = _a.label, id = _a.id, isLoading = _a.isLoading;
    var _b = (0, provider_1.useSelectionContext)(), setSearchQuery = _b.setSearchQuery, searchQuery = _b.searchQuery;
    var handleChange = function (e) {
        setSearchQuery(e.target.value);
    };
    var handleClear = function () { return setSearchQuery(""); };
    var inputId = (0, react_1.useMemo)(function () { return id !== null && id !== void 0 ? id : (0, uuid_1.v4)(); }, [id]);
    return (react_1["default"].createElement("div", { className: SearchInput_module_scss_1["default"].inputSearchContainer },
        react_1["default"].createElement(draft_form_1.InputSearch, { id: inputId, "aria-label": label !== null && label !== void 0 ? label : "Filter options by search query", secondary: true, placeholder: "Search\u2026", value: searchQuery, onChange: handleChange, onClear: handleClear, loading: isLoading })));
};
exports.SearchInput = SearchInput;
exports.SearchInput.displayName = "SearchInput";
//# sourceMappingURL=SearchInput.js.map